import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { EAP_TO_HPI_BANNER_EVENTS } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'
import { EAP_TO_HPI_LINK_DESTINATION } from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/hooks/useGetEapToHpiEligibilityText'
import { EapHpiNotificationType } from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/types'
import { createEapHpiDestinationWebLink } from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/utils'
import { EapToHpiBanner as EapToHpiBannerComponent } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/eapToHpiBanner/EapToHpiBanner'

import { getEapHpiBannerEventProperties } from '../../../data/eapHpiBanner/eapHpiBannerSelectors'
import { useEapHpiBannerData } from '../../../data/eapHpiBanner/useEapHpiBannerData'
import { trackEventWithObj } from '../../../data/mixpanel'
import { useAppDispatch } from '../../../data/storeConfiguration/store'
import { axiosInstance } from '../../http/axiosInstance'
import { triggerEapToHpiBannerCtaAction } from '../banner/banner-actions'

export const EapToHpiBanner: React.FC = () => {
  const { sessionsRemaining, notificationType, dependentName, providerLyraId, sessionType, childLyraId, flowAs } =
    useEapHpiBannerData({
      axiosInstance,
      notificationType: 'homebase',
    })
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const bannerEventProperties = useSelector(getEapHpiBannerEventProperties)

  const onPressLink = async (linkDestination: EAP_TO_HPI_LINK_DESTINATION) => {
    dispatch(
      trackEventWithObj({
        event: EAP_TO_HPI_BANNER_EVENTS.CLICK_EAP_TO_HPI_TRANSITION_HOMEBASE_BANNER,
        ...bannerEventProperties,
      }),
    )

    if (providerLyraId != null) {
      // providerId is required as it is used as a path param in the url and should always be present
      const routeDestination = createEapHpiDestinationWebLink({
        linkDestination,
        providerId: providerLyraId,
        sessionType,
        childLyraId,
      })

      const shouldCompleteEapToHpiBanner = notificationType === EapHpiNotificationType.VIEW_COST_ESTIMATE
      dispatch(triggerEapToHpiBannerCtaAction(shouldCompleteEapToHpiBanner))
      navigate(routeDestination)
    }
  }

  if (notificationType == null) {
    return null
  }

  return (
    <EapToHpiBannerComponent
      onPressLink={onPressLink}
      sessionsRemaining={sessionsRemaining}
      dependentName={dependentName}
      flowAs={flowAs}
      notificationType={notificationType}
      showCloseIcon={false}
    />
  )
}
